// extracted by mini-css-extract-plugin
module.exports = {"s1kkel3d":"s1kkel3d","c1952db0":"c1952db0","l10dsz9g":"l10dsz9g","r18vu9xh":"r18vu9xh"};